import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ShipmentTransportOrderTrackingMapFacade } from './shipment-transport-order-tracking-map.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderTrackingMapGuard {
  constructor(private shipmentTransportOrderTrackingMapFacade: ShipmentTransportOrderTrackingMapFacade) {}

  canActivate({ queryParams }: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    const { transportOrderNumber } = queryParams;
    return checkStoreState(this.shipmentTransportOrderTrackingMapFacade, transportOrderNumber);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderTrackingMapFacade);
  }
}
